// CallAgainCard.js
import React, { useMemo } from 'react';

const CallAgainCard = ({ onCallAgain, isLoading, companyName, customColor, customTextColor, customBackgroundColor }) => {
  const LoadingSpinner = () => (
    <svg
      className="animate-spin h-5 w-5"
      style={{ color: customTextColor || 'white' }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );

  // Determine button colors based on custom color
  const buttonStyle = useMemo(() => {
    if (customColor && customColor.trim() !== '') {
      return {
        backgroundColor: customColor,
        color: customTextColor || 'white'
      };
    }
    return {};
  }, [customColor, customTextColor]);

  const buttonClassName = useMemo(() => {
    const baseClasses = "py-3 px-6 font-semibold rounded-lg shadow-md w-full max-w-lg mx-auto flex items-center justify-center transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-opacity-50 text-sm sm:text-base";

    if (customColor && customColor.trim() !== '') {
      return baseClasses; // Use inline styles for custom colors
    }

    // Default purple styling
    return `${baseClasses} bg-purple-900 text-white hover:bg-purple-800 focus:ring-purple-500`;
  }, [customColor]);

  const titleColor = customColor && customColor.trim() !== '' ? customColor : '#7128d7';
  const backgroundColor = customBackgroundColor && customBackgroundColor.trim() !== '' ? customBackgroundColor : 'white';

  return (
    <div
      className="rounded-lg shadow-lg p-4 sm:p-6 md:p-8 my-4 sm:my-6 md:my-8"
      style={{ backgroundColor }}
    >
      <h2
        className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 text-center"
        style={{ color: titleColor }}
      >
        Want to call again?
      </h2>

      <p className="text-gray-600 text-center mb-6">
        Try another conversation with {companyName}'s AI Assistant
      </p>

      <button
        onClick={onCallAgain}
        className={buttonClassName}
        style={buttonStyle}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <LoadingSpinner />
            <span className="ml-2">Connecting...</span>
          </>
        ) : (
          <span>Call Again</span>
        )}
      </button>
    </div>
  );
};

export default CallAgainCard;
